import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { DragDropContext } from "react-beautiful-dnd";
import {
  AdminGroupDraggableElement,
  InputFieldText,
  ButtonModern,
} from "../components";
import { useRegistrationGroupsContext } from "../context/registrations_groups_context";
import { divisions_url } from "../utils/constants";
import axios from "axios";

const divisionId = 5;

const removeFromList = (list, index) => {
  const result = Array.from(list);
  const [removed] = result.splice(index, 1);
  return [removed, result];
};

const addToList = (list, index, element) => {
  const result = Array.from(list);
  result.splice(index, 0, element);
  return result;
};
/*
const listGroups = [
  {
    id: 1,
    division: "registros",
    group: "registros",
    players: [
      "independentziElRojo",
      "Rioukay",
      "craser09",
      "Profesor Jano",
      "DSR1984",
      "MDkaiserotto",
      "DK_Wolfbrigade",
      "AOP | Charli_Ros",
      "rudyairlines",
      "Drfergav",
      "DK_Murturul",
      "The Revenge Sr",
      "Takii13",
      "Verlok14",
      "LinzE",
    ],
  },
  {
    id: 2,
    division: "1. Paladines",
    group: "A",
    players: [],
  },
  {
    id: 3,
    division: "2. Campeones",
    group: "A",
    players: [],
  },
  {
    id: 4,
    division: "3. Mandobles",
    group: "A",
    players: [],
  },
  {
    id: 5,
    division: "4. Espadas Largas",
    group: "A",
    players: [],
  },
  {
    id: 6,
    division: "5. Hombres de Armas",
    group: "A",
    players: [],
  },
  {
    id: 7,
    division: "5. Hombres de Armas",
    group: "B",
    players: [],
  },
  {
    id: 8,
    division: "6. Alabarderos",
    group: "A",
    players: [],
  },
  {
    id: 9,
    division: "6. Alabarderos",
    group: "B",
    players: [],
  },
  {
    id: 10,
    division: "7. Milicias",
    group: "A",
    players: [],
  },
  {
    id: 11,
    division: "7. Milicias",
    group: "B",
    players: [],
  },
  {
    id: 12,
    division: "8. Piqueros",
    group: "A",
    players: [],
  },
  {
    id: 13,
    division: "8. Piqueros",
    group: "B",
    players: [],
  },
  {
    id: 14,
    division: "9. Lanceros",
    group: "A",
    players: [],
  },
];*/

const AdminGroupDragList = () => {
  const [nameDivision, setNameDivision] = useState("");
  const [groupName, setGroupName] = useState(0);
  const [sequenceGroup, setSequenceGroup] = useState(0);
  const [createDivisionInProgress, setCreateDivisionInProgress] =
    useState(false);
  const [createDivisionError, setCreateDivisionError] = useState(false);
  const [showNewDivisionForm, setShowNewDivisionForm] = useState(false);
  const { regGroupInProgress, regGroupError, regGroups, fetchRegGroups } =
    useRegistrationGroupsContext();

  const [elements, setElements] = useState(regGroups);

  const [saveDivisionError, setSaveDivisionError] = useState(false);
  const [saveDivisionInProgress, setSaveDivisionInProgress] = useState(false);

  useEffect(() => {
    setElements(regGroups);
  }, [regGroups]);

  const createNewDivision = async () => {
    setCreateDivisionError(false);
    setCreateDivisionInProgress(true);

    try {
      const newGroup = {
        name: nameDivision,
        group: groupName,
        season: 5,
        sequence: sequenceGroup,
        image: "",
        players: [],
      };
      const response = await axios.post(divisions_url + divisionId, newGroup);
      if (response.status === 201) {
        setCreateDivisionInProgress(false);
        setShowNewDivisionForm(false);
        fetchRegGroups();
      } else {
        setCreateDivisionInProgress(false);
        setCreateDivisionError(true);
      }
    } catch (error) {
      setCreateDivisionInProgress(false);
      setCreateDivisionError(true);
    }
  };

  const saveDivisions = async () => {
    try {
      setSaveDivisionInProgress(true);

      for (var i = 0; i < elements.length; i++) {
        const response = await axios.post(
          divisions_url + divisionId,
          elements[i]
        );
        if (response.status === 201) {
          setSaveDivisionInProgress(false);
        } else {
          setSaveDivisionInProgress(false);
          setSaveDivisionError(true);
        }
      }

      if (!saveDivisionError) fetchRegGroups();
    } catch (error) {
      setSaveDivisionInProgress(false);
      setSaveDivisionError(true);
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    var listCopy = elements;

    // Remove from source
    var removedElement;

    for (let i = 0; i < listCopy.length; i++) {
      let newSourceList;
      if (listCopy[i].id === parseInt(result.source.droppableId)) {
        [removedElement, newSourceList] = removeFromList(
          listCopy[i].players,
          result.source.index
        );
        listCopy[i].players = newSourceList;
      }
    }

    // Add to destination
    for (let i = 0; i < listCopy.length; i++) {
      let newDestinationList;
      if (listCopy[i].id === parseInt(result.destination.droppableId)) {
        newDestinationList = addToList(
          listCopy[i].players,
          result.destination.index,
          removedElement
        );
        listCopy[i].players = newDestinationList;
      }
    }

    /*
    React use Object.is() to compare if an element has changed, and in complex object doesn't detect the change:
    Object.is(listCopy, elements) => return true
    One easy way to avoid this is by spreading the array into a new array:
    [...listCopy]
    In this case:
    Object.is([...listCopy], elements) => return false
    */
    setElements([...listCopy]);
  };

  if (regGroupInProgress) {
    return <div className="lds-dual-ring"></div>;
  }

  if (regGroupError) {
    return (
      <div className="error">Ha ocurrido un error cargando los inscritos</div>
    );
  }

  return (
    <Wrapper>
      <GroupCreator>
        {elements.map((group) => (
          <div key={group.id} className="group-miniature">
            <p>{group.name}</p>
          </div>
        ))}
        <div
          className="group-miniature addgroup"
          onClick={() => setShowNewDivisionForm(!showNewDivisionForm)}
        >
          +
        </div>
      </GroupCreator>
      {showNewDivisionForm ? (
        <GroupCreatorForm>
          <div>
            <InputFieldText
              title="Nombre Division"
              id="divisionName"
              name="divisionName"
              onChange={(e) => setNameDivision(e.target.value)}
            />
            <InputFieldText
              title="Número grupo"
              id="groupName"
              name="groupName"
              onChange={(e) => setGroupName(e.target.value)}
            />
            <InputFieldText
              title="Orden grupo"
              id="groupSequence"
              name="groupSequence"
              onChange={(e) => setSequenceGroup(e.target.value)}
            />
          </div>
          <div>
            {createDivisionInProgress ? (
              "Creando division..."
            ) : (
              <ButtonModern
                text="Crear división"
                marginLeft="0rem"
                marginRight="0rem"
                marginTop="0rem"
                marginBottom="0rem"
                fontSize="0.8em"
                onClick={() => createNewDivision()}
              />
            )}
            {createDivisionError ? (
              <p>Ha ocurrido un error creando la división (¿existe ya?)</p>
            ) : (
              ""
            )}
          </div>
        </GroupCreatorForm>
      ) : saveDivisionInProgress ? (
        <div className="fixed-button">Guardando...</div>
      ) : (
        <ButtonModern
          text="Guardar cambios"
          marginLeft="0rem"
          marginRight="0rem"
          marginTop="0rem"
          marginBottom="0rem"
          fontSize="0.8em"
          position="fixed"
          right="1%"
          bottom="1%"
          onClick={() => saveDivisions()}
        />
      )}

      <DragDropContextContainer>
        <DragDropContext onDragEnd={onDragEnd}>
          <ListGrid>
            {elements.map((listKey) => (
              <AdminGroupDraggableElement
                elements={listKey.players}
                key={listKey.id}
                prefix={listKey}
              />
            ))}
          </ListGrid>
        </DragDropContext>
      </DragDropContextContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .fixed-button {
    position: fixed;
    right: 1%;
    bottom: 1%;
    background-color: var(--clr-primary-dark-2);
    padding: 1rem;
    width: 200px;
  }
`;
const DragDropContextContainer = styled.div`
  //padding: 20px;
  //border: 4px solid var(--clr-primary);
  //border-radius: 6px;
`;
const ListGrid = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px; */

  display: flex;
  flex-wrap: wrap;
`;

const GroupCreator = styled.div`
  margin: 1rem;
  display: flex;
  align-items: center;

  .group-miniature {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    width: 5rem;
    height: 5rem;
    border: 1px solid var(--clr-primary-dark-2);
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin: 0;
      text-align: center;
    }
  }

  .addgroup {
    cursor: pointer;
    background-color: var(--clr-primary-dark-1);
    border: 1px solid var(--clr-grey-10);
    transition: 0.5s;
    font-size: 68px;
  }

  .addgroup:hover {
    background-color: var(--clr-primary-dark-2);
  }
`;

const GroupCreatorForm = styled.div`
  display: flex;
  align-items: center;
`;

export default AdminGroupDragList;
